import { ArrowDown } from "lucide-react";
import Panel from "./Panel";
import MetaRow from "./MetaRow";

/* ── 02 · Copy Optimizer ── */
const CopyMetric = ({ label, value, delta }) => (
  <div className="flex flex-col gap-1">
    <span className="text-[8px] font-medium uppercase tracking-[0.14em] text-[#A59881] ">
      {label}
    </span>
    <span className="flex items-baseline gap-1">
      <span className="font-inter text-[17px] italic leading-none text-white">
        {value}
      </span>
      {delta && (
        <span className="text-[9px] font-medium text-[#5BD78C]">{delta}</span>
      )}
    </span>
  </div>
);

const CopyOptimizerMock = () => (
  <Panel>
    <MetaRow label="Copy Optimizer · 3 rewrites" right="Tone · Bold + Warm" />
    <hr className="border-white/10 " />
    {/* Original */}
    <div className="rounded-xl border border-[#FF5E8A4D]/[30%] bg-[#FF5E8A0A]/[4%] p-4">
      <div className="flex items-center justify-between">
        <span className="text-[9px] font-medium uppercase tracking-[0.14em] text-[#FF5E8A]">
          — Original
        </span>
        <span className="text-[9px] uppercase tracking-[0.12em] text-[#A59881] ">
          28 words
        </span>
      </div>
      <p className="mt-2.5  font-serif text-[12px] md:text-[16px] 2xl:text-[18px] 3xl:text-[20px] 4xl:text-[22px] leading-[1.55] text-[#C9C0D6]  ">
        Our{" "}
        <span className="line-through decoration-white/3 text-[#C9C0D6]/60 ">
          advanced clinical-grade
        </span>{" "}
        serum is formulated{" "}
        <span className="line-through decoration-white/3 text-[#C9C0D6]/60 ">
          with the latest dermatologist-recommended
        </span>
        ingredients to{" "}
        <span className="line-through decoration-white/3 text-[#C9C0D6]/60 ">
          {" "}
          help support and enhance
        </span>{" "}
        your skin&apos;s natural radiance.
      </p>
      <hr className="border-white/10 mt-1" />
      <div className="mt-3 flex gap-7">
        <CopyMetric label="Clarity" value="52" />
        <CopyMetric label="Hook" value="38" />
        <CopyMetric label="Lift" value="—" />
      </div>
    </div>

    <div className="flex justify-center text-white/25">
      <ArrowDown size={14} />
    </div>

    {/* Optimized */}
    <div className="rounded-xl border border-[#3A61FF4D]/[30%] bg-[#3A7CFF0A]/[4%] p-4">
      <div className="flex items-center justify-between">
        <span className="text-[9px] font-medium uppercase tracking-[0.14em] text-[#A9A0FF]">
          — Optimized
        </span>
        <span className="text-[9px] uppercase tracking-[0.12em] text-white/30">
          14 words
        </span>
      </div>
      <p className="mt-2.5 font-serif text-[12px] md:text-[16px] 2xl:text-[18px] 3xl:text-[20px] 4xl:text-[22px] italic leading-[1.55] text-white/85">
        <span className="bg-[#4F3DF0]/30 px-0.5 not-italic">
          Skip the 12-step routine.
        </span>{" "}
        One serum, visibly brighter skin in 14 days — or it&apos;s on us.
      </p>
      <hr className="border-white/10 mt-1" />
      <div className="mt-3 flex gap-7">
        <CopyMetric label="Clarity" value="91" delta="▲39" />
        <CopyMetric label="Hook" value="84" delta="▲46" />
        <CopyMetric label="Lift" value="+62%" delta="▲" />
      </div>
    </div>
  </Panel>
);

export default CopyOptimizerMock;
